import { ref, reactive, onMounted, onUnmounted, nextTick } from 'vue';
import store from "@/store/index.js";

let token = localStorage.getItem('tokens') || ''; 

const ws_url = "wss://api-aclub.r-erp.cc/api/chat"; 
// const ws_url = "ws://192.168.2.94:1888/api/chat"; 

const webConfig = reactive({
  first: true,
  status: false, // 连接状态
  socketTask: null,
  reconnectCount: 0,
  maxReconnectCount: 5,
  reconnectTimer: null,
  heartbeatTimer: null,
});

/**
 * 
 * const { connect, disconnect, sendMessage } = useWebSocket();
 */
export function useWebSocket() {
  const isConnected = ref(false);
  const messages = ref([]);

  /**
   * 连接 Socket
   */
  const connectSocket = () => {
    if (webConfig.status || webConfig.reconnectCount > webConfig.maxReconnectCount) return;

    webConfig.status = true;
    const socket = new WebSocket(ws_url);

    webConfig.socketTask = socket;

    socket.onopen = handleOpen;
    socket.onmessage = handleMessage;
    socket.onclose = handleClose;
    socket.onerror = handleError;
  };

  /**
   * 连接打开
   */
  const handleOpen = (res) => {
    webConfig.reconnectCount = 0;
    webConfig.status = false;
    isConnected.value = true;

    // 发送登录信息
    const d = {
      type: 1,
      tokens: token
    };
    sendMessage(d);

    // 启动心跳
    heartbeat();
  };

  /**
   * 发送消息
   */
  const sendMessage = (data) => {
    try {
      if (webConfig.socketTask && webConfig.socketTask.readyState === WebSocket.OPEN) {
        webConfig.socketTask.send(JSON.stringify(data));
      } else {
        reconnect();
      }
    } catch (e) {
      console.error('发送异常:', e);
      reconnect();
    }
  };

  /**
   * 接收到消息
   */
  const handleMessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      messages.value.push(data);
      if (messages.value.length > 100) messages.value.shift();

      if (data.type == 1) {
        handleLogin(data);  //登录
      } else if (data.type == 4) {
        // console.log('收到心跳响应'); //心跳
      } else if (data.type == 10) { // 聊天
        if(store.state.chat_this && data.uid != null) {
			store.state.chat_this(data);
		}
      }
    } catch (parseError) {
      console.error('消息解析失败:', parseError);
    }
  };

  /**
   * 登录回调处理
   */
  const handleLogin = (e) => {
    if (e.code == 200) {
    //   console.log('登录成功');
    } else {
    //   console.log('登录失败:', e.msg);
    }
  };

  /**
   * 连接被关闭
   */
  const handleClose = (res) => {
    // console.log('WebSocket 已关闭！', res);
    webConfig.status = false;
    isConnected.value = false;

    if (res.code !== 1000) {
      reconnect();
    }
  };

  /**
   * 连接错误
   */
  const handleError = (err) => {
    // console.error('WebSocket 错误:', err);
    reconnect();
  };

  /**
   * 心跳机制
   */
  const heartbeat = () => {
    if (webConfig.heartbeatTimer) {
      clearInterval(webConfig.heartbeatTimer);
    }

    webConfig.heartbeatTimer = setInterval(() => {
      const d = {
        type: 4,
        tokens: token
      };
      sendMessage(d);
    //   console.log('发送心跳包...');
    }, 30000);
  };

  /**
   * 断线重连逻辑
   */
  const reconnect = () => {
    if (webConfig.reconnectCount >= webConfig.maxReconnectCount) {
    //   console.log(`已达到最大重连次数 ${webConfig.maxReconnectCount}，停止重连`);
      return;
    }

    if (webConfig.reconnectTimer) {
      clearTimeout(webConfig.reconnectTimer);
    }

    webConfig.reconnectCount++;
    const delay = Math.pow(2, webConfig.reconnectCount) * 1000;
    // console.log(`准备第 ${webConfig.reconnectCount} 次重连，${delay / 1000}秒后重试...`);

    webConfig.reconnectTimer = setTimeout(() => {
      webConfig.status = false;
      connectSocket();
    }, delay);
  };

  /**
   * 主动关闭连接
   */
  const disconnect = () => {
    if (webConfig.heartbeatTimer) {
      clearInterval(webConfig.heartbeatTimer);
      webConfig.heartbeatTimer = null;
    }

    if (webConfig.reconnectTimer) {
      clearTimeout(webConfig.reconnectTimer);
      webConfig.reconnectTimer = null;
    }

    if (webConfig.socketTask) {
      webConfig.socketTask.close(1000, "User manually closed");
      webConfig.socketTask = null;
    }
  };

  onMounted(() => {
    if (webConfig.first) {
      connectSocket();
      webConfig.first = false;
    }
  });

  onUnmounted(() => {

  });

  return {
    connectSocket,
    disconnect,
    sendMessage,
    isConnected,
    messages,
  };
}